module.exports = __webpack_public_path__ + "public/img/tianchong.b092885c.jpg";